// Generated by Melange

import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";

function decode(row) {
  return {
    user_id: Mapre_wire__Json.string(row, "user_id"),
    login: Mapre_wire__Json.string(row, "login"),
    role: Mapre_wire__Json.string(row, "role"),
    version: Mapre_wire__Json.integer(row, "version")
  };
}

function update(t, operation) {
  if (/* tag */ typeof operation !== "object" && typeof operation !== "function") {
    switch (operation) {
      case /* Cancel */ 3 :
        return {
          rows: t.rows,
          epoch: t.epoch,
          cursor: t.cursor,
          loading: t.loading,
          busy: t.busy,
          pending: t.pending,
          confirm: undefined,
          message: t.message
        };
      case /* Loading */ 5 :
        return {
          rows: t.rows,
          epoch: t.epoch,
          cursor: t.cursor,
          loading: true,
          busy: t.busy,
          pending: t.pending,
          confirm: t.confirm,
          message: t.message
        };
      case /* Succeeded */ 6 :
        return {
          rows: t.rows,
          epoch: t.epoch,
          cursor: t.cursor,
          loading: t.loading,
          busy: false,
          pending: undefined,
          confirm: t.confirm,
          message: "Membership updated"
        };
      default:
        return t;
    }
  } else {
    switch (operation.TAG) {
      case /* Remove */ 1 :
        return {
          rows: t.rows,
          epoch: t.epoch,
          cursor: t.cursor,
          loading: t.loading,
          busy: t.busy,
          pending: t.pending,
          confirm: operation._0,
          message: ""
        };
      case /* Pending */ 2 :
        return {
          rows: t.rows,
          epoch: t.epoch,
          cursor: t.cursor,
          loading: t.loading,
          busy: true,
          pending: operation._0,
          confirm: undefined,
          message: ""
        };
      case /* Listed */ 3 :
        const rows = operation._0;
        return {
          rows: operation._3 ? Stdlib.$at(t.rows, rows) : rows,
          epoch: operation._1,
          cursor: operation._2,
          loading: false,
          busy: t.busy,
          pending: t.pending,
          confirm: undefined,
          message: t.message
        };
      case /* Failed */ 4 :
        return {
          rows: t.rows,
          epoch: t.epoch,
          cursor: t.cursor,
          loading: false,
          busy: false,
          pending: operation._1 ? t.pending : undefined,
          confirm: undefined,
          message: operation._0
        };
      default:
        return t;
    }
  }
}

function body(op) {
  return JSON.stringify(Js__Js_dict.fromList({
    hd: [
      "request_id",
      Mapre_wire__Json.str(op.request_id)
    ],
    tl: {
      hd: [
        "role",
        Mapre_wire__Json.str(op.role)
      ],
      tl: {
        hd: [
          "expected_version",
          op.member.version
        ],
        tl: {
          hd: [
            "expected_epoch",
            op.epoch
          ],
          tl: /* [] */ 0
        }
      }
    }
  }));
}

const initial = {
  rows: /* [] */ 0,
  epoch: 0,
  cursor: undefined,
  loading: false,
  busy: false,
  pending: undefined,
  confirm: undefined,
  message: ""
};

export {
  initial,
  decode,
  update,
  body,
}
/* Mapre_wire__Json Not a pure module */
